const isAIEnhancedPreviewItem = (previewItem = {}) =>
  previewItem.semanticSearchIncluded === true || previewItem.reactionSummaryEligible === true;

export default isAIEnhancedPreviewItem;
